import React from "react";
import {schemaMatches} from "@jsonforms/core";
import {withJsonFormsControlProps} from "@jsonforms/react";
import {Box, FormControl, FormHelperText} from "@mui/material";
import HtmlEditor from "../../html-editor";
import {RENDERER_TYPES} from "../constants";

export const HtmlEditorTester = schemaMatches(schema => schema.renderer === RENDERER_TYPES.htmlEditor);

export const HtmlEditorRenderer = withJsonFormsControlProps(({data, handleChange, path, errors}) => {
  const isError = Boolean(errors && errors.length > 0);

  return (
    <FormControl fullWidth error={isError} className="custom-json-forms__renderers__html-editor">
      <Box
        sx={{
          border: theme => (isError ? `1px solid ${theme.palette.error.main} !important` : undefined)
        }}
      >
        <HtmlEditor value={data} onChange={value => handleChange(path, value)} />
      </Box>
      {isError && (
        <FormHelperText error sx={{marginLeft: "14px"}}>
          {errors}
        </FormHelperText>
      )}
    </FormControl>
  );
});
